export const androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.cargill.bluviu';

const defaultIosStoreUrl = 'https://apps.apple.com/se/app/bluviu/id1661643152';

const iosStoreUrlsByCountry: { [countryCode: string]: string } = {
  CL: 'https://apps.apple.com/cl/app/bluviu/id1661643152',
  IS: 'https://apps.apple.com/is/app/bluviu/id1661643152',
  NO: 'https://apps.apple.com/no/app/bluviu/id1661643152',
  SE: 'https://apps.apple.com/se/app/bluviu/id1661643152',
  GB: 'https://apps.apple.com/gb/app/bluviu/id1661643152',
};

export const getIosStoreUrl = (countryCode: string): string => iosStoreUrlsByCountry[countryCode] || defaultIosStoreUrl;
